var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNyTimesLogo = function SvgIconNyTimesLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.55 7.616a6.5 6.5 0 0 1 3.23-.987l5.223 2.522a1 1 0 0 0 .435.1 3.625 3.625 0 1 0 0-7.25 1 1 0 0 0 0 2 1.625 1.625 0 0 1 .203 3.237L6.998 2.1A1 1 0 0 0 6.58 2a3.625 3.625 0 0 0-1.876 6.763 8.5 8.5 0 0 0-1.147 5.353q.002.104.027.206a8.5 8.5 0 0 0 4.462 6.328q.114.08.25.126a8.5 8.5 0 0 0 3.69.85h.008a8.5 8.5 0 0 0 8.251-6.44 1 1 0 1 0-1.94-.484 6.5 6.5 0 0 1-5.314 4.847v-9.424a1 1 0 0 0-1.47-.882l-3.345 1.784q-.03.014-.06.032l-2.58 1.377a6.5 6.5 0 0 1 3.014-4.82M5.408 4.438c.26-.244.592-.393.943-.43l2.517 1.215A8.5 8.5 0 0 0 5.954 7.15a1.625 1.625 0 0 1-.546-2.711m1.47 12.69a6.5 6.5 0 0 1-1.203-2.5l1.941-1.035v4.332a6.5 6.5 0 0 1-.738-.797m2.738 2.045v-6.647l1.375-.734v7.755a6.5 6.5 0 0 1-1.375-.374",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconNyTimesLogo;